import { api } from "./client";

export type Source = "env" | "page" | null;
export interface FieldState { set: boolean; ends_in: string | null; source: Source; name?: string | null }
export interface Check { key: string; label: string; ok: boolean; required: boolean; detail: string }
export interface LastTest { ok: boolean; at: string; by: string; checks: Check[] }
export interface TestText {
  id: string; to_masked: string | null; provider: string; status: string; delivery_status: string | null;
  error_code: string | null; meaning: string; sent_at: string; final: boolean;
}
export interface AllowEntry { phone_e164: string; added_by: string | null; added_at: string }
export interface TwilioView {
  environment: "preview" | "production"; provider_mode: string; preview_provider: "mock" | "twilio"; configured_provider: string;
  credential_source: Source; env_overrides: Record<string, boolean>;
  fields: Record<"account_sid" | "auth_token" | "api_key_sid" | "api_key_secret" | "phone_number" | "messaging_service_sid" | "verify_service_sid", FieldState>;
  page_saved: Record<string, { set: boolean; ends_in: string | null } | string | null>;
  suggested_phone_number: string; last_test: LastTest | null; last_test_current: boolean; can_switch_to_real: boolean;
  allowlist: AllowEntry[]; webhooks: { inbound: string; status: string }; test_texts: TestText[]; test_body: string;
}
export interface CredentialsBody {
  account_sid: string; auth_token?: string; api_key_sid?: string; api_key_secret?: string; remove_api_key?: boolean;
  phone_number: string; code: string;
}

const BASE = "/admin/settings/twilio";
export const twilioApi = {
  get: () => api.get<TwilioView>(BASE),
  save: (b: CredentialsBody) => api.put<TwilioView>(`${BASE}/credentials`, b),
  remove: (code: string) => api.post<TwilioView>(`${BASE}/credentials/remove`, { code }),
  test: () => api.post<TwilioView>(`${BASE}/test`),
  provider: (mode: "mock" | "twilio", code: string) => api.put<TwilioView>(`${BASE}/provider`, { mode, code }),
  allow: (phone: string, code: string) => api.post<TwilioView>(`${BASE}/allowlist`, { phone, code }),
  disallow: (phone: string, code: string) => api.post<TwilioView>(`${BASE}/allowlist/remove`, { phone, code }),
  sendTest: (to: string) => api.post<TestText>(`${BASE}/test-text`, { to }),
  testStatus: (id: string) => api.get<TestText>(`${BASE}/test-text/${id}`),
};
